import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ParkingFormRequest} from './parking-form-request.model';

@Injectable({
  providedIn: 'root'
})
export class ParkingFormService {
  private readonly httpClient = inject(HttpClient);
  private readonly formRequestUrl = environment.backendParkingFormRequestUrl;

  sendContactMessage(contactMessage: ParkingFormRequest) {
    return this.httpClient.post(this.formRequestUrl, contactMessage, {observe: 'response', responseType: 'text'});
  }
}
